import React from "react";

export default ({name, type='info', ...props}) => {
  return <a href={'/?tags=' + name}className={"tag is-" + type} {...props}>{name}</a>;
}
